import { render, staticRenderFns } from "./ReservesCard.vue?vue&type=template&id=40de0034&scoped=true&"
import script from "./ReservesCard.vue?vue&type=script&lang=ts&"
export * from "./ReservesCard.vue?vue&type=script&lang=ts&"
import style0 from "./ReservesCard.vue?vue&type=style&index=0&id=40de0034&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40de0034",
  null
  
)

export default component.exports